import { Component, OnInit } from '@angular/core';
var XLSX = require('xlsx');

@Component({
  selector: 'app-exceldownload',
  templateUrl: './exceldownload.component.html',
  styleUrls: ['./exceldownload.component.css']
})
export class ExceldownloadComponent implements OnInit {

  constructor() {
   //this.download();
    let dateFormat = require('dateformat');
   var ms = new Date("2019-02-28").getTime() + 86400000;
   var mst = new Date(ms);
   var next =dateFormat(mst.toDateString(), "yyyy-mm-dd");
   console.log("111now",next);



  }


  ngOnInit() {
  }


  // download1(){
  //   var workbook = XLSX.utils.book_new();
  //   var ws1 = this.uigrid_to_sheet(data, columns);

  //   XLSX.utils.book_append_sheet(workbook, ws1, "Sheet1");
  //   XLSX.writeFile(workbook, 'Driver Trips.xlsx');

  // }


  async download() {


    var wb = XLSX.utils.book_new();
    var configSheetName = 'CONFIG';
    // var cofigColumn = [{'WORKING_HOURS', 'NIGHT_LIMIT', 'NO OF WORKING DAYS', 'MONTHLY SAL'}]
    var cofigData = [
      { working_hours: 'WORKING_HOURS', night_limit: 'NIGHT_LIMIT', no_of_work: 'NO OF WORKING DAYS', monthly_sal: 'MONTHLY SAL' },
      { working_hours: `12:00:00`, night_limit: '20:59:59', no_of_work: 30, monthly_sal: 20889.16 }];

    var consolidateColumn =
    {
      sno: 'S NO',
      pc_no: 'PC NO',
      driver_name: 'Driver name ',
      guest__emp_no: 'Guest Employee Number',
      original_name: 'Original Name',
      cost_center: 'Cost Centre Code',
      groups_cost_center: 'Group as per cost center',
      no_of_days_worked: 'No Of Days Worked',
      present_sal: 'Present Salary ',
      earned_sal: 'Earned Salary (A)',
      normal_ot: 'NORMAL OT',
      ot_amt: 'OT Amount (B)',
      esi: 'ESI @ 4.75%',
      sunday: 'SUNDAY/HOLIDAY AMT',
      night: 'L,Night Allow',
      outstation: 'O,Station Allow',
      gross: 'Gross Total',
      gst: 'GST Tax @ 18%',
      ctc: 'CTC',
      sec: 'SEZ/DTA',
      plant: 'Plant Code',
      gst_in: 'GSTIN Number'
    };

    var consolidatedData = [];
    consolidatedData.push(consolidateColumn);

    var wsc = this.uigrid_to_sheet(cofigData);
    wsc['A2'].z = '[h]:mm:ss';
    wsc['B2'].z = '[h]:mm:ss';
    XLSX.utils.book_append_sheet(wb, wsc, configSheetName);

    var sheetName = 'MIS';
    // var columns = ['DRIVER NAME', 'DATE', 'TIME From', 'TIME To', 'OUTSTATION ALLOWANCE', 'OUTSTATION AMT', 'TOTAL HRS', 'OT HRS', 'Holidays / Sundays', 'OT AMT', 'LATE NIGHT ALLOWANCE hrs', 'LATE NIGHT ALLOWANCE Rs', 'Total', 'esi on voti', 'REMARKS', '', '', ''];
    var driverdata = [{ driver_id: "8807932321", driver_name: "BHUVI" }, { driver_id: "7358262712", driver_name: "SIVA" }]
    var dataraw = [
      { driver_name: "8807932321", date: '21', time_from: "03:30:00", time_to: "18:45:00", out_al: 'NagarKoil' },
      { driver_name: "8807932321", date: '22', time_from: "03:30:00", time_to: "21:45:00", out_al: 'NagarKoil' },
      { driver_name: "8807932321", date: '23', time_from: "03:30:00", time_to: "21:45:00", out_al: 'NagarKoil' },
      { driver_name: "7358262712", date: '21', time_from: "03:30:00", time_to: "21:45:00", out_al: 'NagarKoil' },
      { driver_name: "7358262712", date: '22', time_from: "01:30:00", time_to: "21:45:00", out_al: 'NagarKoil' },
      { driver_name: "7358262712", date: '22', time_from: "01:30:00", time_to: "21:45:00", out_al: 'NagarKoil' },
      { driver_name: "1", date: '21', time_from: "03:30:00", time_to: "21:45:00", out_al: 'NagarKoil' }];
    var header = [];
    // var cntstart = 2;
    header.push({
      driver_name: 'DRIVER NAME',
      date: 'DATE',
      time_from: 'TIME From',
      time_to: 'TIME To',
      out_al: 'OUTSTATION ALLOWANCE',
      out_al_amt: 'OUTSTATION ALLOWANCE AMT',
      tot_hrs: 'TOTAL HRS',
      ot_hrs: 'OT HRS',
      holiday_sun: 'Holidays / Sundays',
      ot_amt: 'OT Amount',
      lat_nit_al: 'LATE NIGHT ALLOWANCE (hrs)',
      nit_al_amt: 'NIGHT ALLOWANCE Rs.',
      tot: 'Total',
      esi_on_ot: 'esi on voti',
      remarks: 'REMARKS',
      attend: 'Attendance',
      present: 'Present',
      dailyamt: 'Daily Amt'

    });

    // dataraw.forEach(res => {
    //   parsed.push(res);
    // })


    var ws = this.uigrid_to_sheet(header);
    ws['!ref'] = XLSX.utils.encode_range({
      s: { c: 0, r: 0 },
      // e: { c: 7, r: 1 + parsed.length + 1 }
      e: { c: 18, r: 1 + dataraw.length *2 }
    });
    var i = 0;
    var sumcnt = 0;

    var sumColmns = [];
    var loopdriver = "";
    var start: number = 2;
    var insertsum: boolean = false;
    var cnt = 0
    var drivercount = 0;
    for (i = 0; i < dataraw.length; i++) {
     
      var n: number = start+cnt;
      cnt++;

      var Acell = `A` + n;
      var Bcell = `B` + n;
      var Ccell = `C` + n;
      var Dcell = `D` + n;
      var Ecell = `E` + n;
      var Fcell = `F` + n;
      var Gcell = `G` + n;
      var Hcell = `H` + n;
      var Icell = `I` + n;
      var Jcell = `J` + n;
      var Kcell = `K` + n;
      var Lcell = `L` + n;
      var Mcell = `M` + n;
      var Ncell = `N` + n;
      var Pcell = `P` + n;
      var Qcell = `Q` + n;
      var Rcell = `R` + n;
      console.log("dataraw", dataraw[0]);
      ws[Acell] = { v: dataraw[i].driver_name };
      ws[Bcell] = { v: dataraw[i].date };
      ws[Ccell] = { v: dataraw[i].time_from };
      ws[Dcell] = { v: dataraw[i].time_to };
      ws[Ecell] = { v: dataraw[i].out_al };
      ws[Fcell] = { f: `=COUNTA(E` + n + `)*550` };
      ws[Gcell] = { f: `=D` + n + `-C` + n };
      ws[Hcell] = { f: `=IF(G` + n + `>CONFIG!$A$2,G` + n + `-CONFIG!$A$2,0)` };
      ws[Icell] = { f: `=IF(G` + n + `>0,1,)*450` };
      ws[Jcell] = { f: `=(H` + n + `)*60*24` };
      ws[Kcell] = { f: `=IF(D` + n + `>CONFIG!$B$2,D` + n + `-CONFIG!$B$2,0)` };
      ws[Lcell] = { f: `=IF(K` + n + `>0,1,)*50` };
      ws[Mcell] = { f: `=J` + n + `+L` + n + `+F` + n + `+I` + n };
      ws[Ncell] = { f: `=+J` + n + `*4.75%` };
      ws[Pcell] = { f: `=IF(G` + n + `,"1",0) & IF(O` + n + ` = "REST",1,0) & IF(O` + n + `="G.O.O.S",1,0) & IF(O` + n + `="LOP",0,0)&IF(O` + n + `="spare",1,0)` };
      ws[Qcell] = { f: `=IF(P` + n + `="00000",0,1)` };
      ws[Rcell] = { f: `=SUM(CONFIG!$D$2/CONFIG!$C$2)*Q` + n };

      //  ws[Ocell] = { f: };
      ws[Ccell].z = '[h]:mm:ss';
      ws[Dcell].z = '[h]:mm:ss';
      ws[Gcell].z = '[h]:mm:ss';
      ws[Hcell].z = '[h]:mm:ss';
      ws[Kcell].z = '[h]:mm:ss';

     
      drivercount = dataraw.filter(elm => elm.driver_name == dataraw[i].driver_name).length;
     
     

      if (cnt == drivercount) {
        cnt = 0;
        var x: number = start + drivercount;
        var drivernamecell = n;
        sumcnt++;
        var drivername = `=MIS!A` + drivernamecell;
        sumColmns.push([drivername, x]);

        var FSumCell = `F` + x; var GSumCell = `G` + x; var HSumCell = `H` + x;
        var ISumCell = `I` + x; var JSumCell = `J` + x; var KSumCell = `K` + x; var LSumCell = `L` + x;
        var MSumCell = `M` + x; var NSumCell = `N` + x; var QSumCell = `Q` + x; var RSumCell = `R` + x;
        var Total = start + drivercount + 1; 
        var TotalA = `A` + Total; 
        var TotalB = `B` + Total;

        ws[FSumCell] = { f: `=SUM(F` + start + `:F` + n + `)` };
        ws[GSumCell] = { f: `=SUM(G` + start + `:G` + n + `)` };
        ws[HSumCell] = { f: `=SUM(H` + start + `:H` + n + `)` };
        ws[ISumCell] = { f: `=SUM(I` + start + `:I` + n + `)` };
        ws[JSumCell] = { f: `=SUM(J` + start + `:J` + n + `)` };
        ws[KSumCell] = { f: `=SUM(K` + start + `:K` + n + `)` };
        ws[LSumCell] = { f: `=SUM(L` + start + `:L` + n + `)` };
        ws[MSumCell] = { f: `=SUM(M` + start + `:M` + n + `)` };
        ws[NSumCell] = { f: `=SUM(N` + start + `:N` + n + `)` };
        ws[QSumCell] = { f: `=SUM(Q` + start + `:Q` + n + `)` };
        ws[RSumCell] = { f: `=SUM(R` + start + `:R` + n + `)` };
        ws[GSumCell].z = '[h]:mm:ss';
        ws[HSumCell].z = '[h]:mm:ss';
        ws[KSumCell].z = '[h]:mm:ss';
        ws[TotalA] = { v: `TOTAL WAGES` };
        ws[TotalB] = { f: `=I` + x + `+J` + x + `+L` + x + `+F` + x + `+R` + x + `+N` + x };
        start = start + drivercount + 2;
        consolidatedData.push({
          sno: sumcnt,
          pc_no: '',
          driver_name: '',
          guest__emp_no: '',
          original_name: '',
          cost_center: '',
          groups_cost_center: '',
          no_of_days_worked: '',
          present_sal: '',
          earned_sal: '',
          normal_ot: '',
          ot_amt: '',
          esi: '',
          sunday: '',
          night: '',
          outstation: '',
          gross: '',
          gst: '',
          ctc: '',
          sec: '',
          plant: '',
          gst_in: ''
        });

      }


    }

    console.log("sumColmns", sumColmns);
    console.log("consolidatedData", consolidatedData);

    var wsconsolidate = this.uigrid_to_sheet(consolidatedData);
    wsconsolidate['!ref'] = XLSX.utils.encode_range({
      s: { c: 0, r: 0 },
      // e: { c: 7, r: 1 + parsed.length + 1 }
      e: { c: 20, r: 1 + consolidatedData.length *2 }
    });

    var j = 0;

    for (j = 0; j < sumColmns.length; j++) {
      console.log("sumColmns[j]",sumColmns[j])
      var m = j + 2;
      var CHcell = `H` + m;
      var CCcell = `C` + m;
      var CIcell = `I` + m;
      var CJcell = `J` + m;
      var CKcell = `K` + m;
      var CLcell = `L` + m;
      var CMcell = `M` + m;
      var CNcell = `N` + m;
      var COcell = `O` + m;
      var CPcell = `P` + m;
      var CQcell = `Q` + m;
      var CRcell = `R` + m;
      var CScell = `S` + m;
      wsconsolidate[CCcell] = { f: sumColmns[j][0] };
      wsconsolidate[CHcell] = { f: `=MIS!Q` + sumColmns[j][1] };
      wsconsolidate[CIcell] = { f: `=CONFIG!$D$2` };
      wsconsolidate[CJcell] = { f: `=I` + m + `/30*H` + m };
      wsconsolidate[CKcell] = { f: `=MIS!H` + sumColmns[j][1] };
      wsconsolidate[CLcell] = { f: `=MIS!J` + sumColmns[j][1] };
      wsconsolidate[CMcell] = { f: `=L` + m + `*4.75%` };
      wsconsolidate[CNcell] = { f: `=MIS!I` + sumColmns[j][1] };
      wsconsolidate[COcell] = { f: `=MIS!L` + sumColmns[j][1] };
      wsconsolidate[CPcell] = { f: `=MIS!F` + sumColmns[j][1] };
      wsconsolidate[CQcell] = { f: `=P` + m + `+O` + m + `+L` + m + `+J` + m + `+N` + m + `+M` + m };
      wsconsolidate[CRcell] = { f: `=Q` + m + `*18%` };
      wsconsolidate[CScell] = { f: `=Q` + m + `+R` + m };
      wsconsolidate[CKcell].z = '[h]:mm:ss';
    }
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    XLSX.utils.book_append_sheet(wb, wsconsolidate, "invoiceTS COPY");
    //var wbout = XLSX.write(wb, wopts);
    
    XLSX.writeFile(wb, 'Driver Trips.xlsx');

  }

  delay = ms => new Promise(res => setTimeout(res, ms));

  uigrid_to_sheet(data) {
    var o = [],
      oo = [],
      i = 0,
      j = 0;

    /* column headers */
    // for (j = 0; j < columns.length; ++j) oo.push((columns[j]));
    // o.push(oo);

    /* table data */
    // for (i = 0; i < data.length; ++i) {
    //   oo = [];
    //   for (j = 0; j < data[i].length; ++j) oo.push((data[i][j]));
    //   o.push(oo);
    // }
    /* aoa_to_sheet converts an array of arrays into a worksheet object */
    //XLSX.utils.aoa_to_sheet(o);

    return XLSX.utils.json_to_sheet(data, { skipHeader: true });
  }

  // s2ab(s) {
  //   if (typeof ArrayBuffer !== 'undefined') {
  //     var buf = new ArrayBuffer(s.length);
  //     var view = new Uint8Array(buf);
  //     for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
  //     return buf;
  //   } else {
  //     var buf = new Array(s.length);
  //     for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF;
  //     return buf;
  //   }
  // }

}
